export default __webpack_public_path__ + "static/media/user_static.ee38a60d.png";